/* eslint-disable sort-keys */
import { CFTokens } from '../../../tokens';
export const BORDER_COLOR = CFTokens.COLOR.BORDER_ALTERNATE_STRONG;
export const BORDER_RADII_CIRCLE = 100;
export const BORDER_RADII_SQUIRCLE = {
    XXS: 6,
    XS: 8,
    SM: 10,
    MD: 14,
    LG: 16,
    XL: 18,
    XXL: 20,
};
export const COLORWAYS = {
    alternate: {
        BACKGROUND: CFTokens.COLOR.BACKGROUND_WARM_2,
        INITIALS: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
    },
    boost: {
        BACKGROUND: CFTokens.COLOR.BACKGROUND_BRAND_DARK,
        INITIALS: CFTokens.COLOR.TEXT_AND_ELEMENT_BOOST,
    },
    default: {
        BACKGROUND: CFTokens.COLOR.BACKGROUND_DEFAULT_DARK,
        INITIALS: CFTokens.COLOR.TEXT_AND_ELEMENT_ACCENT,
    },
};
export const FONT_SIZES = {
    XXS: CFTokens.FONT_SIZE.A,
    XS: CFTokens.FONT_SIZE.C,
    SM: CFTokens.FONT_SIZE.F,
    MD: CFTokens.FONT_SIZE.G,
    LG: CFTokens.FONT_SIZE.H,
    XL: CFTokens.FONT_SIZE.J,
    XXL: CFTokens.FONT_SIZE.M,
};
export const SIZES = {
    XXS: 16,
    XS: 24,
    SM: 32,
    MD: 40,
    LG: 48,
    XL: 56,
    XXL: 64,
};
